import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { sendDuplicatedEmailNotification } from "../../../../../util/email";
import { useUser } from "../../../../../util/user";
import DefaultSelect from "../../../../general/DefaultSelect";
import Req from "../../../../general/Req";

import "../../../IssueListComps/modal.css";

const UserFormElement = (props) => {
	const item = props.item;
	const index = props.index;
	const errors = props.errors;
	const register = props.register;
	const control = props.control;
	const setValue = props.setValue;
	const remove = props.remove;
	const isLoading = props.isLoading;
	const isLIP = props.isLIP;
	const isSolo = props.isSolo;
	const isEditMode = props.isEditMode;
	const siteSelectOptions = props.siteSelectOptions;
	const existingUsers = props.existingUsers;
	const showIndiviSitesSelect = props.showIndiviSitesSelect;
	const setShowIndiviSitesSelect = props.setShowIndiviSitesSelect;
	// const deleteIDs = props.deleteIDs;
	// const setDeleteIDs = props.setDeleteIDs;

	const itemName = `usersObj[${index}]`;

	const currentUser = useUser();

	const checkboxStyle = {
		borderBottomStyle: "none",
	};

	const removeBtnStyle = {
		textAlign: "right",
		paddingRight: "20px",
		color: "red",
	};

	/**
	 * Set site IDs per user object
	 * @param {array} sites
	 * @param {string} inputName
	 */
	const handleMultiSiteOnChange = (sites, inputName) => {
		const tempSites = sites != null ? sites : [];
		const siteIDArray = tempSites.map((site) => site.site_id);
		const siteIDStr = siteIDArray.join(",");
		setValue(inputName, siteIDStr);
	};

	/**
	 * Handle checkbox inputs and site select per user object
	 * @param {obj} e
	 * @param {string} inputName
	 */
	const handleCheck = (e, inputName) => {
		const inputNameSplit = inputName.split(".");
		const isAllSitesCheckbox = inputNameSplit[1] === "seesAllSites";
		const isChecked = e.target.checked;

		setValue(inputName, isChecked);

		// Handles "Sees All Sites" checkbox
		if (isAllSitesCheckbox) {
			let newShowIndiviSites = [];

			// Sees all sites CHECKED
			if (isChecked)
				newShowIndiviSites = showIndiviSitesSelect.filter(
					(itemName) => itemName != inputNameSplit[0]
				);
			// Sees all sites UNCHECKED
			else newShowIndiviSites = [...showIndiviSitesSelect, inputNameSplit[0]];

			setShowIndiviSitesSelect(newShowIndiviSites);
		}
	};

	/**
	 * Render site select
	 * @param {obj} field
	 * @param {string} inputName
	 * @returns Site select component
	 */
	const renderSiteSelect = (field, inputName, isEditMode) => {
		const siteIDStr = field.value != null ? field.value : "";
		let selectedIndivSites = [];

		// Set null as selected sites
		if (siteIDStr == "all") selectedIndivSites = [];
		// Set selected sites of user object
		else {
			const siteIDArray = siteIDStr.split(",");

			selectedIndivSites = siteSelectOptions.filter((sites) =>
				siteIDArray.includes(sites.site_id.toString())
			);
		}

		return (
			<DefaultSelect
				isMulti
				closeMenuOnSelect={false}
				valueContainer={{
					padding: "5px 8px",
				}}
				options={siteSelectOptions}
				isLoading={isLoading}
				defaultValue={selectedIndivSites}
				isDisabled={!isEditMode}
				input={{ height: "15px" }}
				onChange={(data) => handleMultiSiteOnChange(data, inputName)}
			/>
		);
	};

	return (
		<div key={item.user_id} className="user-obj">
			<div className="user-header">
				<Row>
					<Col md="11">
						<h5>User {index + 1}</h5>
						<p className="mandatory-label">(*) is mandatory</p>
						<input
							name={`${itemName}.user_id`}
							ref={register()}
							defaultValue={item.user_id}
							style={{
								visibility: "hidden",
								height: "0",
								padding: "0",
								margin: "0",
							}}
						/>
					</Col>
					<Col md="1" style={removeBtnStyle}>
						{isEditMode && (
							<span
								onClick={() => {
									// if (typeof item.user_id != "undefined") {
									// 	const deleteIDsArray = [...deleteIDs, item.user_id];
									// 	setDeleteIDs(deleteIDsArray);
									// }

									remove(index);
								}}
							>
								<span className="glyphicon glyphicon-remove"></span>
							</span>
						)}
					</Col>
				</Row>
			</div>
			<div className="user-body">
				<Row>
					<Col md="2">
						<h6 for="first_name">
							First Name <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.first_name`}
							ref={register({ required: "*required" })}
							defaultValue={item.first_name}
							readOnly={!isEditMode}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.first_name`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
					<Col md="2">
						<h6 for="last_name">
							Last Name <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.last_name`}
							ref={register({ required: "*required" })}
							defaultValue={item.last_name}
							readOnly={!isEditMode}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.last_name`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
				</Row>
				<Row>
					<Col md="2">
						<h6 for="nick_name">Nickname</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.nick_name`}
							ref={register()}
							defaultValue={item.nick_name}
							readOnly={!isEditMode}
						/>
					</Col>
					<Col md="2">
						<h6 for="email">
							Email Address <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							disabled={item.user_id != ""}
							name={`${itemName}.email`}
							ref={register({
								required: "*required",
								validate: (value) => {
									if (existingUsers.filter(user => parseInt(item.user_id) !== parseInt(user.user_id)).map(user => user.email).includes(value.trim())) {
										const duplicatedEmail = value.trim();
										const userUsingForm = { name: currentUser.name, email: currentUser.email };
										sendDuplicatedEmailNotification(duplicatedEmail, userUsingForm);
										return "Email already existed";
									}
									return true;
								}
							})}
							defaultValue={item.email}
							readOnly={item.user_id !== ""}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.email`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
				</Row>
				<Row>
					<Col md="6"></Col>
					<Col md="2">
						<h6 for="position">
							Position <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.position`}
							ref={register({ required: "*required" })}
							defaultValue={item.position}
							readOnly={!isEditMode}
							disable={!isEditMode}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.position`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
				</Row>
				<Row>
					<Col md="2">
						<label style={isLIP || isSolo ? { display: "none" } : {}}>
							Sees All Sites
						</label>
					</Col>
					<Col md="1">
						<Controller
							name={`${itemName}.seesAllSites`}
							control={control}
							defaultValue={item.seesAllSites}
							readOnly={!isEditMode}
							disable={!isEditMode}
							render={(field, fieldState) => (
								<input
									type="checkbox"
									style={
										isLIP || isSolo
											? { ...checkboxStyle, display: "none" }
											: checkboxStyle
									}
									checked={field.value}
									onChange={(evt) =>
										isEditMode
											? handleCheck(evt, `${itemName}.seesAllSites`)
											: false
									}
								></input>
							)}
						/>
					</Col>
					<Col md="2">
						<label>Receiving e-invoice</label>
					</Col>
					<Col md="1">
						<Controller
							name={`${itemName}.receivingEInvoice`}
							control={control}
							defaultValue={item.receivingEInvoice}
							render={(field, fieldState) => (
								<input
									type="checkbox"
									className=""
									style={checkboxStyle}
									checked={field.value}
									disabled={item.user_id != ""}
									onChange={(evt) =>
										handleCheck(evt, `${itemName}.receivingEInvoice`)
									}
								></input>
							)}
							readOnly={item.user_id != ""}
						/>
					</Col>
					<Col md="2">
						<label>See Invoices</label>
					</Col>
					<Col md="1">
						<Controller
							name={`${itemName}.seesInvoices`}
							control={control}
							defaultValue={item.seesInvoices}
							readOnly={!isEditMode}
							disable={!isEditMode}
							render={(field, fieldState) => (
								<input
									type="checkbox"
									style={checkboxStyle}
									checked={field.value}
									onChange={(evt) =>
										isEditMode
											? handleCheck(evt, `${itemName}.seesInvoices`)
											: false
									}
								></input>
							)}
						/>
					</Col>
					<Col md="2">
						<label>See Reports</label>
					</Col>
					<Col md="1">
						<Controller
							name={`${itemName}.seesReports`}
							control={control}
							defaultValue={item.seesReports}
							readOnly={!isEditMode}
							disable={!isEditMode}
							render={(field, fieldState) => (
								<input
									type="checkbox"
									style={checkboxStyle}
									checked={field.value}
									onChange={(evt) =>
										isEditMode
											? handleCheck(evt, `${itemName}.seesReports`)
											: false
									}
								></input>
							)}
						/>
					</Col>
				</Row>
				{showIndiviSitesSelect.includes(itemName) && !isLoading && !isSolo && (
					<Row>
						<Col md="2">
							<h6 for={`${itemName}.site_id`}>
								Sites <Req />
							</h6>
							<ErrorMessage
								errors={errors}
								name={`${itemName}.site_id`}
								render={({ message }) => <Req message={message} />}
							/>
						</Col>
						<Col md="7">
							<Controller
								name={`${itemName}.site_id`}
								control={control}
								defaultValue={item.site_id}
								rules={{
									required: "*required",
									validate: (value) => value != "all" || "*required",
								}}
								render={(field, fieldState) =>
									renderSiteSelect(field, `${itemName}.site_id`, isEditMode)
								}
							/>
						</Col>
					</Row>
				)}
			</div>
		</div>
	);
};

export default UserFormElement;
